<div class="af-not-found">
  <div class="card">
      <div class="form-field">
        <div class="top">
          <span class="title"><b>Not found - AutoForm Cloud</b></span>
        </div>

        <div class="af-not-found-box">
          <p>Page not found</p>
        </div>
      </div>
  </div>
</div>
